import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

type AreaClientiRedirectProps = {
  message?: string
  ctaLabel?: string
  ctaLink?: string
  onClick?: () => void
}

export function AreaClientiRedirect({
  message = 'Non puoi accedere a questa pagina',
  ctaLabel = 'Vai alle bilance',
  ctaLink = '/bilance',
  onClick,
}: AreaClientiRedirectProps) {
  return (
    <div className="d-flex h-100 bg-primary">
      <div className="bg-primary d-flex flex-column justify-content-center align-items-center w-100 h-100">
        <img
          src="/statik/main/LOGO.svg"
          height={40}
          alt=""
          className="d-block mb-5"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.display = 'none'
          }}
        />
        <h1 className="mt-5 px-3 heading-h3 text-white text-center">{message}</h1>
        {onClick ? (
          <Button onClick={onClick} variant="light" className="mt-4">
            {ctaLabel}
          </Button>
        ) : (
          <Button as={Link as any} to={ctaLink} variant="light" className="mt-4">
            {ctaLabel}
          </Button>
        )}
      </div>
    </div>
  )
}
